<div class="modal-header">
  <h4 class="modal-title">Add Proposal</h4>
</div>
<div class="modal-body">
  <dx-form [formData]="proposal" [colCount]="2">
    <dxi-item dataField="created" [label]="{ text: 'Date' }"></dxi-item>
    <dxi-item itemType="empty"></dxi-item>

    <dxi-item [label]="{ text: 'Proposal' }" [colSpan]="2">
      <div *dxTemplate>
        <dx-text-area [(value)]="proposal.description" [height]="150"> </dx-text-area>
      </div>
    </dxi-item>
    <dxi-item [label]="{ text: 'Notes' }" [colSpan]="2">
      <div *dxTemplate>
        <dx-text-area [(value)]="proposal.notes" [height]="200"> </dx-text-area>
      </div>
    </dxi-item>
    <dxi-item dataField="fromCommittee"></dxi-item>

    <dxi-item [label]="{ text: ' ' }">
      <div *dxTemplate>
        <dx-select-box
          [(value)]="proposal.fromCommittee"
          [dataSource]="committees"
          valueExpr="name"
          displayExpr="name"
          [searchEnabled]="true"
          [showClearButton]="true"
          [acceptCustomValue]="true"
          (onCustomItemCreating)="addCustomItem($event)"
        ></dx-select-box>
      </div>
    </dxi-item>
    <dxi-item dataField="toCommittee" [label]="{ text: 'To Committee' }"></dxi-item>
    <dxi-item [label]="{ text: '' }">
      <div *dxTemplate>
        <dx-select-box
          [(value)]="proposal.toCommittee"
          [items]="committees"
          valueExpr="name"
          displayExpr="name"
          [searchEnabled]="true"
          [showClearButton]="true"
          [acceptCustomValue]="true"
        ></dx-select-box>
      </div>

    </dxi-item>
    <dxi-item dataField="showPreview" [label]="{ text: 'Show Preview in Email' }" editorType="dxCheckBox"></dxi-item>
    <dxi-item itemType="empty"></dxi-item>
    <dxi-item dataField="allowDiscussion" [label]="{ text: 'Allow Discussion' }" editorType="dxCheckBox"></dxi-item>
    <dxi-item itemType="empty"></dxi-item>
    <dxi-item dataField="congregationalVote" [label]="{ text: 'Congregational Vote' }" editorType="dxCheckBox" [disabled]="true"></dxi-item>
    <dxi-item itemType="empty"></dxi-item>
    @if (proposal.allowDiscussion && mode === 'new') {
      <dxi-item [label]="{ text: 'Initial Discussion' }" [colSpan]="2">
        <div *dxTemplate>
          <dx-text-area [(value)]="initialDiscussion" [height]="100"> </dx-text-area>
        </div>
      </dxi-item>
    }
  </dx-form>

  @if (proposal.allowDiscussion && discussions?.length > 0) {
    <div class="widget-content user">
      <table class="table mt-3">
        <thead>
          <tr>
            <th>Name</th>
            <th>Note</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          @for (note of discussions; track note) {
            <tr>
              <td class="col-xs-5">{{ note.person?.displayName }}</td>
              <td class="col-xs-5">{{ note.note }}</td>
              <td class="col-xs-1">{{ note.created | date }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (executiveAdmin && mode !== 'new') {
    <div class="widget-content user">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Person</th>
            <th>Yes Vote</th>
            <th>No Vote</th>
          </tr>
        </thead>
        <tbody>
          <tr [hidden]="proposal.proposalVotes.length > 0">
            <td colspan="9">No items</td>
          </tr>
          @for (data of proposal.proposalVotes; track data) {
            <tr [ngStyle]="{ 'background-color': 'white' }" [hidden]="proposal.proposalVotes.length === 0">
              <td style="padding: 6px">{{ data.person?.displayName }}</td>
              <td style="padding: 6px">{{ data.yesVote ? 'Yes' : '' }}</td>
              <td style="padding: 6px">{{ data.noVote ? 'No' : '' }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }

  @if (!executiveAdmin && mode !== 'new') {
    <div>
      <div style="font-weight: bold; text-decoration: underline">VOTE INFORMATION</div>
      <div>Total Votes: {{ votes?.length }}</div>
      <div>Yes: {{ yesVotes }}</div>
      <div>No: {{ noVotes }}</div>
    </div>
  }
</div>
<div class="modal-footer">
  @if (clerkReview && congregationalVotes !== 0 && proposal?.congregationalVote) {
    <button (click)="sendGeneratedVotes()" class="btn btn-danger me-auto">
      Send Congregational Votes: {{ congregationalVotes }}
    </button>
  }
  <button class="btn btn-primary" (click)="save()" [disabled]="saving">Save</button>
  <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
